import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';
import { MatChipInputEvent } from '@angular/material';

@Component({
    selector: 'app-audit',
    templateUrl: 'audit.component.html',
    styleUrls: ['./audit.component.css']
})
export class AuditComponent implements OnInit {
    @Input() dataAuditoria: any;

    boolAuditoria : boolean = false;
    constructor(private router: Router) {}

    ngOnInit() {}

	toogleAuditoria():void{
        this.boolAuditoria = !this.boolAuditoria;
	}
}